import {isString, isInteger, inRange} from 'lodash';

import initializeTierOptions from 'Map/configurer/initializeTierOptions';
import {trafficFlowStyleSchemaParser} from './styleOptionInitialization/tierStyleSchemaParser';
import {isStylePlainObject} from './styleOptionInitialization/validators';
import ThemeWrapper from './styleOptionInitialization/themeWrapper';

const validateThickness = (thickness, theme) => {
    if (!thickness) {
        return undefined;
    }
    /**
     * This condition protects us from setting thickness for styles, which doesn't support this
     * parameter.
     **/
    if (theme.options.style === 'relative0' || theme.options.style === 'relative0-dark') {
        return undefined;
    }
    if (!(isInteger(thickness) && inRange(thickness, 1, 21))) {
        throw new Error('Thickness must be an integer in range from 1 to 20.');
    }

    return thickness;
};

export default function initializeTrafficFlowOptions(inputOptions) {
    if (!inputOptions) {
        return null;
    }

    const options = {
        ...initializeTierOptions(inputOptions)
    };
    if (!inputOptions.style) {
        options.theme = trafficFlowStyleSchemaParser('tomtom://vector/1/relative');
    } else if (isStylePlainObject(inputOptions.style)) {
        options.theme = new ThemeWrapper(ThemeWrapper.TYPE.OBJECT, {
            styleObject: inputOptions.style
        });
    } else if (isString(inputOptions.style)) {
        options.theme = trafficFlowStyleSchemaParser(options.style);
    }

    const thickness = validateThickness(inputOptions.thickness, options.theme);
    if (thickness) {
        options.thickness = thickness;
    } else {
        delete options.thickness;
    }

    if (!inputOptions.refresh) {
        options.refresh = 180000;
    } else {
        options.refresh = inputOptions.refresh;
        if (options.refresh < 30000) {
            options.refresh = 30000;
        }
    }

    return options;
}



// WEBPACK FOOTER //
// ./map/configurer/initializeTrafficFlowTilesOptions.js